import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';
import i18n from 'i18n';

const fields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: 'E-mail',
    stateKey: 'email',
    validateOnChange: true,
  },
  {
    gridXs: 12,
    label: i18n.t('PASSWORD_KEY'),
    stateKey: 'password',
    isPassword: true,
    validateOnChange: true,
  },
];

export default fields;
